<template>
    <div class="task-breakdown-table">
      <h2>Task Summary</h2>
      <table>
        <thead>
          <tr class="bold-row">
            <th>Task</th>
            <th>Task Count</th>
            <th>Total Hours</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item,index in taskReportTable" :key="index + item.date + item.task_name + item.department_name" :class="{'bold-row':index == taskReportTable.length-1}">
            <td>{{ item.task_title }}</td>
            <td>{{ item.count }}</td>
            <td>{{ item.total_minutes }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      taskReportTable: {
        type: Array,
        required: true,
      },
    },
 
  };
  </script>
  
  <style scoped>
  .task-breakdown-table {
    margin: 20px;
    border-collapse: collapse;
    width: 100%;
  }
  
  .task-breakdown-table h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .task-breakdown-table table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .task-breakdown-table th,
  .task-breakdown-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .task-breakdown-table th {
    background-color: #f2f2f2;
    color: black;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  
  .task-breakdown-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .task-breakdown-table tr:hover {
    background-color: #ddd;
  }

  .bold-row {
  font-weight: bold;
}
  </style>